const validate = (data, schema) => {
  const errors = [];
  const validateValue = (value, schema2, path) => {
    switch (schema2.type) {
      case "string": {
        const stringSchema = schema2;
        if (typeof value !== "string") {
          errors.push({ path, message: "Expected string", value });
          return;
        }
        if (stringSchema.enum && !stringSchema.enum.includes(value)) {
          errors.push({ path, message: `Must be one of: ${stringSchema.enum.join(", ")}`, value });
        }
        if (stringSchema.pattern && !new RegExp(stringSchema.pattern).test(value)) {
          errors.push({ path, message: `Does not match pattern ${stringSchema.pattern}`, value });
        }
        if (stringSchema.format === "uuid") {
          const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
          if (!uuidRegex.test(value)) {
            errors.push({ path, message: "Must be a valid UUID", value });
          }
        }
        break;
      }
      case "integer": {
        const integerSchema = schema2;
        if (typeof value !== "number" || !Number.isInteger(value)) {
          errors.push({ path, message: "Expected integer", value });
          return;
        }
        if (integerSchema.const !== void 0 && value !== integerSchema.const) {
          errors.push({ path, message: `Must be exactly ${integerSchema.const}`, value });
        }
        break;
      }
      case "object": {
        const objectSchema = schema2;
        if (typeof value !== "object" || value === null || Array.isArray(value)) {
          errors.push({ path, message: "Expected object", value });
          return;
        }
        const obj = value;
        for (const key of objectSchema.required || []) {
          if (!(key in obj)) {
            errors.push({ path: `${path}.${key}`, message: "Missing required property", value: void 0 });
          }
        }
        for (const [key, val] of Object.entries(obj)) {
          const propSchema = objectSchema.properties[key];
          if (!propSchema) {
            if (objectSchema.additionalProperties === false) {
              errors.push({ path: `${path}.${key}`, message: "Unexpected property", value: val });
            }
            continue;
          }
          validateValue(val, propSchema, `${path}.${key}`);
        }
        break;
      }
      default:
        errors.push({ path, message: `Unsupported schema type: ${schema2.type}`, value });
    }
  };
  validateValue(data, schema, "");
  return { valid: errors.length === 0, errors };
};

export { validate };
//# sourceMappingURL=validator.js.map
